<template>
  <div class="mt-200">
    <div class="is-size-6 has-text-weight-bold ml-50 mb-100">Notify the following users</div>
    <div class="columns users">
      <div class="column mr-50 p-0" v-for="user in users" :key="user.id" style="flex: none; width: 30px;">
        <app-avatar :user-id="user.id"></app-avatar>
      </div>
      <status-automation-set-users
        :selected-users="users"
        class="column p-0"
        style="max-width: 30px"
        @setUsers="val => { $emit('setUsers', { prop: 'usersToNotify', val }) }"
        :smallLabel="users.length ? '' : 'Set Users'"
      ></status-automation-set-users>
    </div>
    <p class="ml-50 is-size-8 has-text-light"><strong>NOTE:</strong> Each user will determine how they want to be notified via their profile settings.</p>
  </div>
</template>

<script>
import StatusAutomationSetUsers from './StatusAutomationSetUsers';

export default {
  name: 'StatusNotifyUsersAutomation',
  components: {
    StatusAutomationSetUsers
  },
  props: {
    users: Array,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.users {
  padding: 10px;
  width: 100%;
  margin-right: 0;
  margin-left: 0;

  p {
    font-size: 11px;
    font-weight: bold;
  }
}
</style>
